import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import config from 'config';
import Section from 'components/Section';
import { Divider, Paper } from '@material-ui/core';

const Accessibility = () => {
  // scroll to top when entering page view
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <>
      <Helmet>
        <title>
          Saavutettavuusseloste | {config.site.name}
        </title>
      </Helmet>
      <Section className="section--page">
        <Paper elevation={2}>
          <div className="page-wrapper">
            <h1 className="page-title">
              LAKITUTKA.FI – Saavutettavuusseloste
            </h1>
            <Divider />
            <h2>
              1 Teknistä tietoa verkkosivuston
              saavutettavuudesta
            </h2>
            <p>
              Turun yliopisto pyrkii takaamaan
              verkkosivustonsa saavutettavuuden Euroopan
              parlamentin ja neuvoston
              saavutettavuusdirektiivin mukaisesti. Suomessa
              saavutettavuusdirektiivin toteuttaa laki
              digitaalisten palveluiden tarjoamisesta.
            </p>
            <p>
              Tämä saavutettavuusseloste koskee
              lakitutka.fi-verkkosivustoa.
            </p>
            <h3>
              1.1 Verkkosivuston saavutettavuuden tila
            </h3>
            <p>
              Tämä verkkosivusto täyttää 
              <a href="https://www.w3.org/TR/WCAG21/">
                Web Content Accessibility Guidelines (WCAG)
                2.1
              </a>
              -standardin AA-tason saavutettavuusvaatimukset
              osittain.
            </p>
            <h3>1.2 Ei-saavutettava sisältö</h3>
            <p>
              Lakitutka.fi-verkkosivustolla oleva ”näytä
              visualisointi”-ominaisuus ei ole saavutettava,
              mutta sama tieto on saatavilla haun tuloksissa
              ilman visualisointia.
            </p>
            <h2>
              2 Miten tämä saavutettavuusseloste on laadittu
            </h2>
            <p>
              Seloste on laadittu 09.09.2021. Sivuston
              saavutettavuuden on arvioinut Turun Yliopisto,
              Tutkimuksen IT.
            </p>
            <p>
              Selostetta tarkistettiin viimeksi 09.09.2021.
            </p>
            <p>
              Saavutettavuustestaus suoritettiin Google
              Chrome, Mozilla Firefox sekä Microsoft Edge
              selaimilla.
            </p>
            <p>
              Saavutettavuustestauksessa hyödynnettiin WAVE
              ja aXe nimisiä selain laajennuksia.
              Laajennuksien lisäksi käytettiin
              NVDA-ruudunlukijaa sekä W3C:n HTML
              validaattoria.
            </p>
            <p>
              Sisällön testaus suoritettiin pääsääntöisesti
              käsin.
            </p>
            <h2>3 Palaute ja yhteystiedot</h2>
            <p>
              Jos huomaat sivustolla saavutettavuusongelmia,
              anna ensin palautetta meille eli sivuston
              ylläpitäjälle osoitteeseen kirjaamo@utu.fi.
              Vastauksessa voi mennä 14 päivää.
            </p>
            <p>
              Jos et ole tyytyväinen saamaasi vastaukseen
              tai et saa vastausta lainkaan kahden viikon
              aikana, voit tehdä ilmoituksen{' '}
              <a href="https://www.saavutettavuusvaatimukset.fi/oikeutesi/">
                Etelä-Suomen aluehallintovirastoon
              </a>
              . Etelä-Suomen aluehallintoviraston sivulla
              kerrotaan tarkasti, miten ilmoituksen voi
              tehdä ja miten asia käsitellään.
            </p>
            <h2>3.1 Valvontaviranomaisen yhteystiedot</h2>
            <p>Etelä-Suomen aluehallintovirasto</p>
            <p>Saavutettavuuden valvonnan yksikkö</p>
            <p>
              <a href="http://www.saavutettavuusvaatimukset.fi/">
                www.saavutettavuusvaatimukset.fi
              </a>
            </p>
            <p>saavutettavuus@avi.fi</p>
            <h2>
              4 Teemme jatkuvasti työtä saavutettavuuden
              parantamiseksi
            </h2>
            <p>
              <a href="https://www.utu.fi/fi/yliopisto/saavutettavuus">
                Saavutettavuus Turun yliopistossa
              </a>
            </p>
          </div>
        </Paper>
      </Section>
    </>
  );
};

export default Accessibility;
